// extracted by mini-css-extract-plugin
export var navTabletBackdrop = "NavMenuTablet-module--navTabletBackdrop--d3a61";
export var navTabletWrapper = "NavMenuTablet-module--navTabletWrapper--9f25f";
export var searchMenu = "NavMenuTablet-module--searchMenu--d45e1";